import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ModalBasicLayout from "../../Modal/ModalBasicLayout";
import Button from "../../Buttons/Button";
import {
  WARNING,
  INSTAGRAM_FEED_ASPECT_RATIO_WARNING,
  BUTTON_GO_BACK,
  BUTTON_RESIZE_AND_CONTINUE,
  BUTTON_PUBLISH_NOW,
} from "../../../i18n/keysTranslations";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";

const InstagramAspectRatioModal = ({
  open,
  onBack,
  onContinueWithoutChanges,
  onResizeAndContinue,
}) => {
  const { t } = useTranslation();

  return (
    <ModalBasicLayout
      modalOpen={open}
      onCloseModal={onBack}
      ariaLabel="instagram-aspect-ratio-warning"
      maxWidth="sm"
      fullWidth
      hasTitle={false}
      titleContent={false}
      showCloseButton={false}
      sxContent={{ p: 3 }}
      enableHistoryManagement={false}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: 2,
        }}
      >
        <InfoRoundedIcon sx={{ fontSize: 70, color: "#FFBB28 !important" }} />

        <Typography
          variant="body1"
          sx={{ fontWeight: 600, fontSize: 30, color: "text.primary" }}
        >
          {t(WARNING)}
        </Typography>

        <Typography
          variant="body1"
          sx={{ fontSize: 16, color: "text.primary" }}
        >
          {t(INSTAGRAM_FEED_ASPECT_RATIO_WARNING)}
        </Typography>

        <Box
          sx={{
            mt: 2,
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <Button color="secondary" onClick={onBack}>
            {t(BUTTON_GO_BACK)}
          </Button>
          <Button color="secondary" onClick={onContinueWithoutChanges}>
            {t(BUTTON_PUBLISH_NOW)}
          </Button>
          <Button color="primary" onClick={onResizeAndContinue}>
            {t(BUTTON_RESIZE_AND_CONTINUE)}
          </Button>
        </Box>
      </Box>
    </ModalBasicLayout>
  );
};

export default InstagramAspectRatioModal;
